import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/tm-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/tm-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/tm-calculator",
      title: m.tm_meta_title(),
      description: m.tm_meta_description(),
      toolName: m.tm_tool_name(),
      faqs: [
        { q: m.tm_faq_q1(), a: m.tm_faq_a1() },
        { q: m.tm_faq_q2(), a: m.tm_faq_a2() },
        { q: m.tm_faq_q3(), a: m.tm_faq_a3() },
        { q: m.tm_faq_q4(), a: m.tm_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
